// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_b7-0";
export var optionCard = "_b7-1";